<template>
  <div class='accordion'>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    created () {
      this.$root.$on('collapseAll', () => {
        this.collapseAll()
      })

      this.$root.$on('expandAll', () => {
        this.expandAll()
      })
    },
    computed: {
      sections () {
        return this.$children.filter(child => child.$el.classList.contains('collapsible-section'))
      }
    },
    methods: {
      collapseAll () {
        this.sections.forEach(section => {
          try {
            section.$children[0].$refs.collapseButton.collapse()
          } catch (error) {
          // nothing
          }
        })
      },
      expandAll () {
        this.sections.forEach(section => {
          try {
            section.$children[0].$refs.collapseButton.expand()
          } catch (error) {
          // nothing
          }
        })
      }
    }
  }
</script>
